{
  "messages": {
    "unknown": "Okänt fel",
    "unwellEnvironment": "Du har blivit utloggad eller tappat kontakt med systemet. Vänligen försök logga in igen.",
    "errorTitle": "Ett fel har uppstått!",
    "unknownErrorAdminInfo": "Ett okänt fel, eller ett fel som saknar felmeddelande har uppstått. Kontakta systemadministratören.",
    "someError": "Något gick fel",
    "nameMissing": "Namn saknas",
    "nothingFound": "Ingenting hittades",
    "articleMissingTitle": "Artikeldokument saknas",
    "articleMissingDescription": "Inget artikeldokument är angivet. Navigera tillbaka till översikten och försök igen.",
    "embeddedFactboxMissing": "Faktarutan kunde inte öppnas. Navigera tillbaka till översikten och försök igen.",
    "failedFetchingDocument": "Misslyckades hämta dokument.",
    "failedUpdatingListRetrying": "Misslyckades att automatiskt uppdatera listan. Försöker igen om {{seconds}} sekunder.",
    "noResultsFound": "Inga resultat hittades",
    "copyError": "Kopiera felmeddelande",
    "validationError": "Valideringsfel",
    "documentTypeMissing": "{{documentType}} saknas",
    "documentTypeMissingDescription": "Inget {{documentType, lowercase}} är angivet. Navigera tillbaka till översikten och försök igen.",
    "couldNotCreateNewFactbox": "Kunde inte skapa ny faktaruta!",
    "statusChangeforDocumentTypeFailed": "Kunde inte ändra status på {{documentType, lowercase}}! Det gick inte att hitta en kopplad planering.",
    "scheduleArticleFailed": "Kunde inte schemalägga artikel! Tid eller datum är felaktigt angivet.",
    "createQuickArticleFailed": "Fel när två på två skapades.",
    "flashCreationFailed": "Flashen kunde inte skapas.",
    "createAssignmentError": "Flashen har skapats. Tyvärr misslyckades det att koppla den till en planering.",
    "failedToLoadHistory": "Det uppstod ett fel när dokumenthistoriken skulle hämtas.",
    "failedToLoadMetaData": "Ett fel uppstod vid hämtning av metadata.",
    "saveAssignmentError": "Kunde inte spara uppdraget",
    "createDeliverableError": "Kan inte skapa leverabel",
    "changeStatusError": "Det gick inte att ändra status. Uppdragets publiceringstid kunde inte ändras i den kopplade planeringen.",
    "loadFailed": "Kunde inte ladda",
    "noDeliverables": "Inga leverabler",
    "documentCreationFailed": "{{type}} kunde inte skapas.",
    "documentCreatedAssignmentFailed": "{{type}} har skapats. Tyvärr misslyckades det att koppla den till en planering.",
    "planningSectionMissing": "Den valda planeringens sektion kunde inte hittas. Försök att logga ut och logga in igen.",
    "planningLackingSection": "Den valda planeringen saknar sektion. Lägg till en sektion i den valda planeringen."
  },
  "toasts": {
    "couldNotCreateNewEvent": "Kunde inte skapa ny händelse!",
    "couldNotCreateNewPlanning": "Kunde inte skapa ny planering!",
    "snapshotError": "Planeringen har ändrats lokalt men gick inte att spara.",
    "createDeliverableLinkError": "Kunde inte länka leverabel",
    "saveError": "Kunde inte spara planeringen",
    "saveChangeError": "Kunde inte spara ändringen",
    "missingMetadata": "Saknar nyhetsvärde eller sektion",
    "missingTimelessCategory": "Saknar tidlös kategori",
    "assignmentMoveError": "Uppdraget kunde inte flyttas",
    "assignmentMoveErrorNotLoggedIn": "Uppdraget kunde inte flyttas. Du är inte inloggad.",
    "assignmentMoveErrorTryAgain": "Uppdraget kunde inte flyttas. Var god försök igen.",
    "couldNotSaveAfterMove": "Kunde inte spara efter flytt.",
    "getPlanningsFailed": "Kunde inte hämta planeringar",
    "getEventsFailed": "Kunde inte hämta händelser",
    "getSearchResultsFailed": "Kunde inte hämta sökresultat",
    "unableToAutorise": "Kan inte autentisera mot bildtjänsten",
    "showPictureFailed": "Kan inte visa bilden, ogiltigt id.",
    "sendDataError": "Kunde inte skicka data",
    "multipleAuthors": "Flera författardokument hittades, kontakta support",
    "unpublishError": "Det gick inte att avpublicera dokumentet",
    "addAssignmentToPlanningError": "Det gick inte att lägga till uppdraget i en kopplad planering",
    "creationFailed": "Misslyckades att skapa text: {{error}}",
    "fetchDocumentFailed": "Kunde inte hämta dokument",
    "couldNotScheduleArticle": "Kunde inte schemalägga artikel! Tid eller datum är felaktigt angivet.",
    "savedDocumentFailed": "Kunde inte spara dokument",
    "fetchStatusFailed": "Ett fel uppstod när aktuell status skulle hämtas. Försök ladda om sidan.",
    "couldNotChangeStatusReloadBrowser": "Ett fel har uppstått, aktuell status kunde inte ändras! Ladda om webbläsaren och försök igen.",
    "couldNotChangeStatus": "Ett fel uppstod när aktuell status skulle ändras.",
    "couldNotSaveStatus": "Ett fel uppstod när aktuell status skulle sparas.",
    "failedToFillArticleHeadline": "Rubriken kunde inte fyllas i automatiskt. Uppdragets rubrik används ändå som artikelns rubrik.",
    "couldNotFindPlanningSection": "Kunde inte hitta sektionen för planeringen",
    "authorUpdateFailure": "Kunde inte uppdatera författardokument: {{errorMessage}}",
    "authorSaveFailure": "Kunde inte spara författardokument: {{errorMessage}}",
    "authorCreateFailure": "Kunde inte skapa författardokument: Failed to create author doc",
    "authorCreateUndefinedFailed": "Kunde inte skapa författardokument: Failed to fetch author document: undefined",
    "couldNotOpenEmbeddedFactbox": "Kunde inte ladda faktarutan. Vänligen navigera tillbaka till översikten och försök igen.",
    "couldNotLoadFactbox": "Kunde inte ladda faktarutan. Vänligen försök igen."
  },
  "systemMessages": {
    "connectionFailed": "Misslyckades att ansluta till meddelandetjänsten, vänligen ladda om fönstret."
  }
}
